// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f822dd7","316":"1d053e10","336":"cef610ad","338":"c702866f","455":"11e2c09c","570":"004a8230","645":"ba6dcf47","883":"886df327","977":"ce821ba1"}[chunkId] + ".chunk.js";
};